// Angular modules
import { NgModule }                from '@angular/core';
import { Injector }                from '@angular/core';
import { APP_INITIALIZER }         from '@angular/core';
import { OverlayContainer }        from '@angular/cdk/overlay';
import { HttpClientModule }        from '@angular/common/http';
import { HTTP_INTERCEPTORS }       from '@angular/common/http';
import { HttpClient }              from '@angular/common/http';
import { BrowserModule }           from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Internal modules
import { StaticModule }            from './static/static.module';
import { SharedModule }            from './shared/shared.module';
import { AppRoutingModule }        from './app-routing.module';
import { environment }             from '../environments/environment';

// External modules
import { TranslateService }        from '@ngx-translate/core';
import { TranslateModule }         from '@ngx-translate/core';
import { TranslateLoader }         from '@ngx-translate/core';
import { TranslateHttpLoader }     from '@ngx-translate/http-loader';

// Components
import { AppComponent }            from './app.component';

// Services
import { AuthService }             from './shared/services/auth.service';
import { ApiService }              from './shared/services/api.service';
import { DynamicListFieldService } from './shared/components/blocks/filter-engine/dynamic-list-field/dynamic-list-filed.service';
import { NotificationService }     from './shared/components/blocks/notification/notification.service';


// Interceptors
import { HeaderInterceptor }       from './shared/interceptors/header.interceptor';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports      :
  [
    // Angular modules
    HttpClientModule,
    BrowserAnimationsModule,
    BrowserModule,

    // External modules
    TranslateModule.forRoot({
      useDefaultLang: true,
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),

    // Internal modules
    SharedModule,
    StaticModule,
    AppRoutingModule,
  ],
  declarations :
  [
    AppComponent
  ],
  providers    :
  [
    // Internal modules
    { provide : 'environment', useValue : environment },
    { provide : HTTP_INTERCEPTORS, useClass : HeaderInterceptor, multi : true },

    // Services
    AuthService,
    ApiService,
    DynamicListFieldService,
    NotificationService,

    // Pipes

    // Interceptors
  ],
  bootstrap    :
  [
    AppComponent
  ]
})
export class AppModule
{
  constructor(overlayContainer : OverlayContainer)
  {
    overlayContainer.getContainerElement().classList.add('default-theme');
  }
}

export function createTranslateLoader(http : HttpClient) : TranslateHttpLoader
{
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
